"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/helpers/ucfirst.js
// module id = 877
// module chunks = 0